'use client'
import styled from 'styled-components'
import { mq, vw, getP50, createUnderline } from '@/styles'
import { motion } from 'framer-motion'
import { type FC, useState } from 'react'
import { usePathname } from 'next/navigation'
import { ButtonBack, SectionContents } from '@/components'
import { useMount } from '@/hooks'

type Props = {
  paragraphs: any
  media: any
}


export const MainHomesAndContracts: FC<Props> = ({ paragraphs, media }) => {
  const isMount = useMount()
  const pathname = usePathname()
  const [showOverlay, setShowOverlay] = useState(false)

  return isMount && (
    <>
      <DivOverlay className='overlay' $showOverlay={showOverlay} $pathname={pathname} />
      <Main variants={homePagevariants} initial='initial' animate={'animate'} exit='exit'>
        <ButtonBack setShowOverlay={setShowOverlay}/>
        <SectionContents images={media} paragraphs={paragraphs} />
      </Main>
    </>
  )
}

const DivOverlay = styled.div<any>`
  background-color: ${({ $pathname }) => ($pathname === '/' || $pathname === '/es-ES' ) ? 'var(--color-darkgreen)' : 'var(--color-beige)'};
  min-height: 100vh;
  height: 100%;
  opacity: ${({ $showOverlay }) => $showOverlay ? 1 : 0};
  position: absolute;
  top: 0;
  transition: all 500ms linear;
  width: 100%;
  z-index: ${({ $showOverlay }) => $showOverlay ? 800 : 0};
`

const Main = styled(motion.main)`
  grid-column: 1 / span 6;
  margin: ${vw(50, 'mobile')} ${vw(10, 'mobile')};

  ${mq.greaterThan('nexus7')} {
    margin: ${vw(50, 'nexus7')} ${vw(10, 'nexus7')};
  }

  ${mq.greaterThan('tablet')} {
    grid-column: 1 / span 12;
    margin: ${vw(100, 'desktop')};
  }

  ${mq.greaterThan('container')} {
    margin: 100px;
  }

  .dy {
    color: red;
  }

  p:not(.dy) {
    ${getP50()}
    color: var(--color-darkgreen);
  }
  .back {
    display: inline-block;
    text-align: left;
  }

  section {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    a {
      ${createUnderline({ color: 'darkgreen', height: 2, reverse: true })}
    }
  }
`

export const homePagevariants = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1,
    transition: {
      duration: .8,
      type: 'spring',
      ease: 'linear',
      delay: 1.5,
      stiffness: 80,
      damping: 20,
      mass: 1
    }
  },
  exit: {
    opacity: 0,
    duration: .1,
  }
}